import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { ArchiveModule } from '@features/archive/archive.module';
import { CyclesModule } from '@features/cycles/cycles.module';
import { FormRendererModule } from '@features/forms/form-renderer-module';
import { LocationFilteringModule } from '@features/location-filtering/location-filtering.module';
import { CharityBucketsModalComponent } from '@features/programs/charity-buckets-modal/charity-buckets-modal.component';
import { ImportExportProgramsModalComponent } from '@features/programs/import-export-programs-modal/import-export-programs-modal.component';
import { ProgramCommunicationComponent } from '@features/programs/program-communication/program-communication.component';
import { SelectEmailTemplateModule } from '@features/system-emails/select-email-template/select-email-template.module';
import { SystemEmailsModule } from '@features/system-emails/system-emails.module';
import { WorkflowModule } from '../workflow/workflow.module';
import { AutoDeclineModalComponent } from './auto-decline-modal/auto-decline-modal.component';
import { BaseProgramsPageComponent } from './base-programs-page/base-programs-page.component';
import { CreateProgramModalComponent } from './create-program-modal/create-program-modal.component';
import { GrantProgramStepComponent } from './grant-program-step/grant-program-step.component';
import { ProgramOrgEligibilityDefaultMessagePipe } from './pipes/program-org-eligibility-default-message.pipe';
import { ProgramAutomationModule } from './program-automation/program-automation.module';
import { ProgramDeadlineModalComponent } from './program-deadline-modal/program-deadline-modal.component';
import { ProgramDetailsComponent } from './program-details/program-details.component';
import { ProgramDetailFlyoutComponent } from './program-flyout/program-detail-flyout/program-detail-flyout.component';
import { ProgramFormModalComponent } from './program-form-modal/program-form-modal.component';
import { ProgramFormsComponent } from './program-forms/program-forms.component';
import { ProgramSettingsComponent } from './program-settings/program-settings.component';
import { ProgramTabsComponent } from './program-tabs/program-tabs.component';
import { ProgramWorkflowComponent } from './program-workflow/program-workflow.component';
import { ProgramsPageWrapperComponent } from './programs-page-wrapper/progams-page-wrapper.component';
import { TranslateProgramsPageComponent } from './translation/translate-programs-page/translate-programs-page.component';

@NgModule({
  imports: [
    CommonModule,
    GCCoreModule,
    WorkflowModule,
    SystemEmailsModule,
    SelectEmailTemplateModule,
    ArchiveModule,
    CyclesModule,
    FormRendererModule,
    ProgramAutomationModule,
    LocationFilteringModule
  ],
  declarations: [
    ProgramsPageWrapperComponent,
    BaseProgramsPageComponent,
    ProgramDetailsComponent,
    ProgramFormsComponent,
    TranslateProgramsPageComponent,
    ProgramWorkflowComponent,
    ProgramDeadlineModalComponent,
    CharityBucketsModalComponent,
    ProgramFormModalComponent,
    GrantProgramStepComponent,
    ImportExportProgramsModalComponent,
    ProgramCommunicationComponent,
    ProgramTabsComponent,
    ProgramSettingsComponent,
    CreateProgramModalComponent,
    AutoDeclineModalComponent,
    ProgramOrgEligibilityDefaultMessagePipe,
    ProgramDetailFlyoutComponent
  ]
})
export class ProgramsModule { }
